(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fk-flash-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('fk-flash-coupon')) {
  customElements.define('fk-flash-coupon', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.controller = new AbortController();
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-fk-copy]');
        if (!button || !this.contains(button) || button.disabled) return;
        const input = this.querySelector('input');
        const status = this.querySelector('[role="status"]');
        if (!input || !input.value.trim()) return;
        button.disabled = true;
        try {
          if (!navigator.clipboard || !window.isSecureContext) throw new Error('manual');
          await navigator.clipboard.writeText(input.value);
          if (this.isConnected) status.textContent = this.dataset.success;
        } catch (_) {
          if (this.isConnected) {
            input.focus(); input.select(); input.setSelectionRange(0, input.value.length);
            status.textContent = this.dataset.manual;
          }
        } finally { if (this.isConnected) button.disabled = false; }
      }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.bound = false; }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video_guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideoGuide = (root) => {
      if (!root || root.dataset.nbvgInitialized === 'true') return;
      root.dataset.nbvgInitialized = 'true';

      const tabs = Array.from(root.querySelectorAll('.nbvg__tab'));
      const panels = Array.from(root.querySelectorAll('.nbvg__panel'));
      const sectionId = root.dataset.sectionId;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visibilityObserver = null;

      const resetVideo = (video) => {
        if (!video) return;

        video.pause();

        try {
          video.currentTime = 0;
        } catch (error) {
          /* An unloaded video can reject seeking in some browsers. */
        }
      };

      const playVideoFromStart = (video) => {
        if (!video) return;

        video.muted = true;
        video.playsInline = true;

        try {
          video.currentTime = 0;
        } catch (error) {
          /* Playback will still begin when the media becomes ready. */
        }

        try {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        } catch (error) {
          /* Keep the selected poster visible if autoplay is unavailable. */
        }
      };

      const activateTab = (tab, shouldPlay = true) => {
        const activePanel = panels.find((panel) => panel.dataset.panel === tab.dataset.target);
        if (!activePanel) return;

        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel) => {
          const selected = panel === activePanel;
          const video = panel.querySelector('video');
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);

          if (!selected) resetVideo(video);
        });

        const video = activePanel.querySelector('video');
        if (video && shouldPlay) playVideoFromStart(video);

        if (window.matchMedia('(max-width: 749px)').matches) {
          tab.scrollIntoView({
            behavior: reduceMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab, true));

        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          tabs[nextIndex].focus();
          activateTab(tabs[nextIndex], true);
        });
      });

      const onBlockSelect = (event) => {
        const tab = event.target.closest && event.target.closest('.nbvg__tab');
        if (tab && root.contains(tab)) activateTab(tab, false);
      };

      const cleanup = () => {
        panels.forEach((panel) => resetVideo(panel.querySelector('video')));
        if (visibilityObserver) visibilityObserver.disconnect();
        document.removeEventListener('shopify:block:select', onBlockSelect);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
        delete root.dataset.nbvgInitialized;
      };

      const onSectionUnload = (event) => {
        if (event.detail && event.detail.sectionId === sectionId) cleanup();
      };

      document.addEventListener('shopify:block:select', onBlockSelect);
      document.addEventListener('shopify:section:unload', onSectionUnload);

      if ('IntersectionObserver' in window) {
        visibilityObserver = new IntersectionObserver((entries) => {
          if (entries[0] && !entries[0].isIntersecting) {
            panels.forEach((panel) => {
              const video = panel.querySelector('video');
              if (video && !video.paused) video.pause();
            });
          }
        }, { threshold: 0.01 });

        visibilityObserver.observe(root);
      }
    };

    document.querySelectorAll('.nbvg').forEach(initializeVideoGuide);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches && event.target.matches('.nbvg')) initializeVideoGuide(event.target);
      if (event.target.querySelectorAll) event.target.querySelectorAll('.nbvg').forEach(initializeVideoGuide);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
